// 部品 ボタン左中央配置用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  children: React.ReactNode;
}

const RowLeftAndCenterAlignmentButton: React.FC<Props> = ({ children }) => {
  return (
    <Row className="row-left-and-center-alignment-buttons">
      <Col className="text-start-left-and-center">{children}</Col>
    </Row>
  );
};

export default RowLeftAndCenterAlignmentButton;
